import { translateAdmin } from '../../../utils/adminTranslations';
import AdminText from '../AdminText';
import React, { useState } from 'react';
import { apiUrl } from '../../../config';
import { useLanguage } from '../../../LanguageContext';
import LanguageChanger from '../../../utils/modules/LanguageChanger';
const RoomView = ({ room, onClose }) => {
    const [viewRoom] = useState(room);
    const { language } = useLanguage();

    return (
        <div className='system-background-hide'>
            <section className="system-container system-container-form">
                <div className='system-container__inner'>
                    <header className="system-header"><AdminText>Просмотр</AdminText></header>
                    <div className="system-form">
                        <LanguageChanger />
                        <div className="system-input-box">
                            <label><AdminText>Тип номера</AdminText></label>
                            <input disabled placeholder="" value={viewRoom.translations.room_type[language] ? viewRoom.translations.room_type[language] : ''} type="text" name='room_type' />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Общедоступные номера</AdminText></label>
                            <input disabled placeholder={translateAdmin("Число")} value={viewRoom.count} type="number" name='count' />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Описание</AdminText></label>
                            <textarea disabled placeholder="" value={viewRoom.translations.description[language] ? viewRoom.translations.description[language] : ''} type="text" name='description'></textarea>
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Дополнительная информация</AdminText></label>
                            <textarea disabled placeholder="" value={viewRoom.translations.additional_info[language] ? viewRoom.translations.additional_info[language] : ''} type="text" name='additional_info'></textarea>
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Количество номеров</AdminText></label>
                            <input disabled placeholder={translateAdmin("Число")} value={viewRoom.count_total} type="number" name='count_total' />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Цена, летний сезон</AdminText></label>
                            <input disabled placeholder={translateAdmin("Число")} value={viewRoom.price_summer} type="number" name='price_summer' />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Цена, зимний сезон</AdminText></label>
                            <input disabled placeholder={translateAdmin("Число")} value={viewRoom.price_winter} type="number" name='price_winter' />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Максимальное количество гостей, которые могут разместиться в номере</AdminText></label>
                            <input disabled placeholder={translateAdmin("Число")} value={viewRoom.capacity} type="number" name='capacity' />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Количество комнат в номере</AdminText></label>
                            <input disabled placeholder={translateAdmin("Число")} value={viewRoom.rooms_count} type="number" name='rooms_count' />
                        </div>
                        <div className='flex-btns'>
                            <button type='button' className="system-booking-table-btn system-booking-table-btn-cancel" onClick={onClose}><AdminText>Закрыть</AdminText></button>
                        </div>
                    </div>
                </div>
                <div>
                    {viewRoom.images && viewRoom.images.length > 0 && (
                        <div className="system-container__inner system-container__inner-images">
                            <div className="system-container__inner__images">
                                <header className="system-header"><AdminText>Фотографии</AdminText></header>
                                {viewRoom.images.map((image, index) => (
                                    <div className='system-header__view-image' key={index}>
                                        <img 
                                            src={apiUrl + `/api/images/${image}`}
                                            alt={`Room ${index}`}
                                        />
                                    </div>
                                ))}
                                </div>
                        </div>
                    )}
                    {viewRoom.videos && viewRoom.videos.length > 0 && (
                        <div className="system-container__inner system-container__inner-images">
                            <div className="system-container__inner__images">
                                <header className="system-header"><AdminText>Видео</AdminText></header>
                                {viewRoom.videos.map((video, index) => (
                                    <div className='system-header__view-image' key={index}>
                                        <video
                                            src={apiUrl + `/api/videos/${video}`}
                                            controls
                                            width="320"
                                            height="240"
                                        >
                                            <AdminText>Ваш браузер не поддерживает видео.</AdminText>
                                        </video>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}

export default RoomView;